import { createAction } from '@ngrx/store';

export const logout = createAction('[Authentication] Logout User');

export const userActivityAction = createAction(
    '[Authentication] User Activity'
);
